import * as S from "./LoginTemplate.style";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { useNavigate } from "react-router";
import { ModalJoinRestriction } from "@/components/organisms/Modals/ModalJoinRestriction";
import { ReactComponent as IconLogo } from "@/styles/assets/svg/logo_main.svg";

interface LoginTemplateProps {
  children: React.ReactElement;
}

export const LoginTemplate = ({ children }: LoginTemplateProps) => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <S.LoginTemplate>
        <S.LogoBox>
          <IconLogo width={90} height={90} />
          청소년 척추건강
        </S.LogoBox>
        {children}
        <S.ButtonBox>
          <Buttons
            type="button"
            size="join"
            color="primary100"
            layout="text"
            label="회원가입"
            onClick={() => navigate("/auth/join/type")}
            /** 실증 인원 1,000명 이상이 되었으므로 회원가입 제한 */
            // onClick={() => setModalShow(true)}
          />
          <S.Separator />
          <Buttons
            type="button"
            size="join"
            color="primary100"
            layout="text"
            label="아이디 찾기"
            onClick={() => navigate("/auth/account/find-id")}
          />
          <S.Separator />
          <Buttons
            type="button"
            size="join"
            color="primary100"
            layout="text"
            label="비밀번호 찾기"
            onClick={() => navigate("/auth/account/find-password")}
          />
        </S.ButtonBox>
      </S.LoginTemplate>
      {modalShow && <ModalJoinRestriction setModalShow={setModalShow} />}
    </>
  );
};
